import { apiClient } from '@/shared/lib/api/api-client'
import type {
  BulkClassifyInput,
  BulkClassifyResult,
  Category,
  CreateTagInput,
  SetClassificationInput,
  Tag,
  TagOverview,
  TransactionClassification,
} from '../types/tagging'

// Core paths: apiClient rewrites the leading `/api/` to the gateway's `/api/core/`.

export function fetchCategories(signal?: AbortSignal): Promise<Category[]> {
  return apiClient.get<Category[]>('/api/tagging/categories', signal)
}

export function fetchTags(signal?: AbortSignal): Promise<Tag[]> {
  return apiClient.get<Tag[]>('/api/tagging/tags', signal)
}

export function createTag(input: CreateTagInput): Promise<Tag> {
  return apiClient.post<Tag>('/api/tagging/tags', input)
}

export function fetchTagsOverview(signal?: AbortSignal): Promise<TagOverview[]> {
  return apiClient.get<TagOverview[]>('/api/tagging/tags/overview', signal)
}

export function updateTag(tagId: number, input: CreateTagInput): Promise<Tag> {
  return apiClient.put<Tag>(`/api/tagging/tags/${tagId}`, input)
}

export function deleteTag(tagId: number): Promise<void> {
  return apiClient.delete<void>(`/api/tagging/tags/${tagId}`)
}

export function fetchTransactionClassification(
  transactionId: number,
  signal?: AbortSignal,
): Promise<TransactionClassification> {
  return apiClient.get<TransactionClassification>(`/api/tagging/transactions/${transactionId}`, signal)
}

export function setTransactionClassification(
  transactionId: number,
  input: SetClassificationInput,
): Promise<TransactionClassification> {
  return apiClient.put<TransactionClassification>(`/api/tagging/transactions/${transactionId}`, input)
}

export function bulkClassifyTransactions(input: BulkClassifyInput): Promise<BulkClassifyResult> {
  return apiClient.post<BulkClassifyResult>('/api/tagging/transactions/bulk', input)
}
